import React from "react";

const About=()=>{
    return  <h1>About Page</h1>
   
}
export default About;